import {createDialogOverlay, fillDialog, pvpButton} from "./DialogHelpers.js";
import {hostDialogAvailable, requestHostToolPrompt} from "./HostDialog.js";

import {t} from "./i18n/index.js";
// Modal popup asking for the Pipe tool's optional wall thickness
// ("Godstykkelse [mm]") at tool activation, per spec: presented when the
// tool is activated, applies only to the registration now being created,
// and is read once - never re-prompted mid-capture (see tools/pipeTool.js).
//
// Resolves to:
//   a number  - the wall thickness in mm the user entered
//   null      - the user explicitly continued without one (field left empty)
//   undefined - the user cancelled (Annuller / ESC / tool switched away),
//               meaning the whole tool activation should be aborted
export function promptWallThickness(dm){
	// Vært-UI (PointViews frontend) viser dialogen; uden vært (standalone Potree) bruges DOM-dialogen herunder.
	if(hostDialogAvailable(dm.viewer)){
		return requestHostToolPrompt(dm.viewer, {
			kind: 'form',
			size: 's',
			title: t('Rør - godstykkelse'),
			text: t('Angiv rørets godstykkelse i mm, hvis den er kendt. Feltet kan efterlades tomt.'),
			fields: [{id: 'wallThickness', type: 'number', label: t('Godstykkelse [mm] - valgfri'), step: 'any'}],
			confirmLabel: t('Fortsæt'),
		}).then((result) => {
			if(result.action !== 'confirm') return undefined;
			const raw = result.values.wallThickness;
			const num = parseFloat(raw);
			return (raw === '' || !isFinite(num)) ? null : num;
		});
	}
	return new Promise((resolve) => {
		const {overlay, box} = createDialogOverlay(dm, 280);
		fillDialog(box, {
			title: t(`Rør - godstykkelse`),
			description: t(`Angiv rørets godstykkelse i mm, hvis den er kendt. Feltet kan efterlades tomt.`),
			body: `<input class="pvp-input" type="number" min="0" step="any" placeholder="${t("Godstykkelse [mm] - valgfri")}"
			 />`,
			actions: pvpButton('cancel', t("Annuller")) + pvpButton('continue', t("Fortsæt"), 'primary'),
		});

		const input = box.querySelector('input');
		input.focus();

		let done = false;
		const cleanup = () => {
			dm.viewer.removeEventListener('cancel_insertions', onCancelEvent);
			document.body.removeChild(overlay);
		};
		const finish = (value) => {
			if(done) return;
			done = true;
			cleanup();
			resolve(value);
		};

		const submit = () => {
			const raw = input.value;
			const num = parseFloat(raw);
			finish((raw === '' || !isFinite(num)) ? null : num);
		};

		const onCancelEvent = () => finish(undefined);

		box.querySelector('[data-action="continue"]').addEventListener('click', submit);
		box.querySelector('[data-action="cancel"]').addEventListener('click', () => finish(undefined));
		box.addEventListener('keydown', (e) => {
			// stopPropagation: the popup's own input is focused, which makes
			// DigitizationModule's global Escape handler skip itself (it treats
			// a focused text field as "editing a value, not cancelling the
			// tool") - so Escape must be handled here directly instead.
			if(e.key === 'Escape'){ e.stopPropagation(); finish(undefined); }
			if(e.key === 'Enter'){ e.preventDefault(); submit(); }
		});

		// covers ESC pressed outside the popup, or the tool being switched
		// away from some other way while the popup is still open
		dm.viewer.addEventListener('cancel_insertions', onCancelEvent);
	});
}
